var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPhoto = function SvgPhoto(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#CCC",
    d: "M5 21q-.824 0-1.412-.587A1.93 1.93 0 0 1 3 19V5q0-.824.587-1.412A1.93 1.93 0 0 1 5 3h14q.824 0 1.413.587Q21 4.176 21 5v14q0 .824-.587 1.413A1.93 1.93 0 0 1 19 21zm0-2h14V5H5zm1-2h12l-3.75-5-3 4L9 13zm2.5-7q.624 0 1.063-.437Q10 9.125 10 8.5t-.437-1.062A1.45 1.45 0 0 0 8.5 7q-.625 0-1.062.438A1.45 1.45 0 0 0 7 8.5q0 .624.438 1.063Q7.875 10 8.5 10"
  })));
};
export { SvgPhoto as ReactComponent };
export default __webpack_public_path__ + "static/media/photo.ab7608ff.svg";